export default "__VITE_ASSET__373c7fdf__"